var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM12.48 6.6C12.3675 7.785 11.88 10.665 11.6325 11.9925C11.5275 12.555 11.3175 12.7425 11.1225 12.765C10.6875 12.8025 10.3575 12.48 9.9375 12.2025C9.2775 11.7675 8.9025 11.4975 8.265 11.0775C7.5225 10.59 8.0025 10.32 8.43 9.885C8.5425 9.7725 10.4625 8.025 10.5 7.8675C10.5052 7.84364 10.5045 7.81888 10.498 7.79535C10.4914 7.77183 10.4793 7.75025 10.4625 7.7325C10.4175 7.695 10.3575 7.71 10.305 7.7175C10.2375 7.7325 9.1875 8.43 7.14 9.81C6.84 10.0125 6.57 10.1175 6.33 10.11C6.06 10.1025 5.55 9.96 5.1675 9.8325C4.695 9.6825 4.3275 9.6 4.3575 9.3375C4.3725 9.2025 4.56 9.0675 4.9125 8.925C7.1025 7.9725 8.5575 7.3425 9.285 7.0425C11.37 6.1725 11.7975 6.0225 12.0825 6.0225C12.1425 6.0225 12.285 6.0375 12.375 6.1125C12.45 6.1725 12.4725 6.255 12.48 6.315C12.4725 6.36 12.4875 6.495 12.48 6.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.5f6dd102aeb685f41516f68d6f2eb36b.svg";
export { ForwardRef as ReactComponent };